namespace SPA {
	export namespace Contacts {
		export class ContactList extends Backbone.Collection<SPA.Contact> {
			public constructor(models?: SPA.Contact[], options?: any) {
				super(models, options);
			}

			public preinitialize(models?: SPA.Contact[], options: any = {}): void
			{
				this.url = location.protocol + '//' + Wollmilch.URL + AJAXCallbase_e.REALTOR + 'contact/list';

				// Not sure if you need that with correct Collection Model extend
				this.model = SPA.Contact;
			}

			public initialize(models?: SPA.Contact[], initOptions?: any): void
			{
				// Init event listeners
			}

			public fetch(options: Backbone.CollectionFetchOptions = {}): JQueryXHR
			{
				options.beforeSend = this.addHeaders;

				// Don't forget to pass the options, we need the additional headers
				return super.fetch(options);
			}

			public parse(response: Wollmilch.ResponseObject) {
				return response.data;
			}

			public modelId(attr: IContact) {
				return attr.ContactID;
			}

			private addHeaders(xhr: JQuery.jqXHR) {
				xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
				xhr.setRequestHeader('GSDWollmilch-API-AuthToken', Wollmilch.AuthToken);
				xhr.setRequestHeader('GSDWollmilch-API-Key', 'API-KEY');
			}
		}
	}
}
